'use strict';

class MarketplaceCalculator {

    constructor() {

        this.LIMITS = {
            box: {
                minVolume: 0.0001,
                maxVolume: 0.1,
                minWeight: 1,
                maxWeight: 30,
                maxL: 60,
                maxW: 40,
                maxH: 40
            },
            big: {
                minVolume: 0.1,
                maxVolume: 1000,
                minWeight: 30,
                maxWeight: 1200,
                maxL: 80,
                maxW: 120,
                maxH: 240
            }
        };

        this.initComponents();
        this.bindEvents();
    }

initComponents() {
   
    this.cityPickupSelect = new MarketplaceSelect2Component('#marketplacecalculation-city_pickup_code');
       
    this.pvzSelect = new MarketplaceSelect2Component('#pvz-select', {
        placeholder: 'Выберите филиал',
        allowClear: true,
        width: '100%',
        language: {
            noResults: function() {
                return "Нет доступных филиалов";
            },
            searching: function() {
                return "Поиск...";
            }
        }
    });

    this.deliveryBranchsSelect = new MarketplaceSelect2Component('#delivery-branch-select', {
        placeholder: 'Выберите филиал',
        allowClear: true,
        width: '100%',
        language: {
            noResults: function() {
                return "Нет доступных филиалов";
            },
            searching: function() {
                return "Поиск...";
            }
        }
    });
    
    // Менеджер мест
    this.placesManager = new MarketplacePlacesManager('#places-container', this.LIMITS);
    
    // Добавляем контейнер для сообщений о тарифе, если его нет
    if (!$('#tariff-message').length) {
        $('#limits-box').after('<div id="tariff-message" class="alert mt-3" style="display: none;"></div>');
    }
    
    // Инициализируем контейнер для результатов расчета
    this.resultContainer = $('#calculation-result');

    //this.deliverySelector = new MarketplaceDeliverySelector('.delivery-selector', this);
  
    this.pvzLoadTimeout = null;
}

    bindEvents() {
        this.bindCitySelectionEvents();
        this.bindPlacesEvents();
        this.bindTariffEvents();
        this.bindFormSubmit();
        this.bindClearResultsEvents();
         this.bindSelect2FocusEvents();
    }

    bindClearResultsEvents() {
        const self = this;

        this.cityPickupSelect.element.on('change', function() {
            self.clearCalculationResults();
        });

       /* $('#marketplacecalculation-city_delivery_code').on('change', function() {
            self.clearCalculationResults();
        });*/
        $('#marketplacecalculation-city_delivery_code').on('change', function() {
            self.clearCalculationResults();
        });
        this.pvzSelect.element.on('change', function() {
            self.clearCalculationResults();
        });

        $('#marketplacecalculation-declared_price').on('input', function() {
            self.clearCalculationResults();
        });

        $('#marketplacecalculation-confirmation_price').on('change', function() {
            self.clearCalculationResults();
        });

        $('.tariff-card').on('click', function() {
            self.clearCalculationResults();
        });

        $(document).on('input', '.length, .width, .height, .weight, .count_place', function() {
            self.clearCalculationResults();
        });

        $('.add-place').on('click', function() {
            self.clearCalculationResults();
        });

        $(document).on('click', '.remove-place', function() {
            self.clearCalculationResults();
        });
    }

    clearCalculationResults() {
        this.resultContainer.empty();
    }

    bindCitySelectionEvents() {
    const self = this;
    
    // Очищаем филиалы при инициализации
    this.resetPvzSelect();
    
    // Событие при выборе города
    this.cityPickupSelect.element.on('select2:select', function(e) {
        const data = e.params.data;
        if (data && data.id) {
            // Устанавливаем КЛАДР код
            $('#marketplacecalculation-kladrcode').val(data.id);
            
            // Показываем индикатор загрузки в селекте филиалов
            self.showPvzLoading();
            
            self.loadPvzList(data.code);
        }
    });
    
    // Событие при очистке города
    this.cityPickupSelect.element.on('select2:clear', function() {
        
        $('#marketplacecalculation-kladrcode').val('');
                  self.resetPvzSelect();
    });
   
// Событие при выборе филиала
this.pvzSelect.element.on('change', function() {
    const selectedValue = self.pvzSelect.getValue();
    
    if (selectedValue) {
        const $selectedOption = self.pvzSelect.element.find('option:selected');
        const selectedTown = $selectedOption.attr('data-town');
        const parentTown = $selectedOption.attr('data-parent-town');
        
        
        
        const townForKladr = parentTown || selectedTown;
        
        if (townForKladr) {
          
            $('#marketplacecalculation-parent-town-code').val(townForKladr);
           $('#marketplacecalculation-dispatch_address_code').val(townForKladr);      
            self.loadKladrCode(townForKladr);
            self.loadDispatchCode(townForKladr);
            
        }
    } else {
        $('#marketplacecalculation-dispatch_address_code').val('');
        $('#marketplacecalculation-parent-town-code').val('');
    }
});
}

/**
 * Показать индикатор загрузки в селекте филиалов
 */
showPvzLoading() {
    this.pvzSelect.clearOptions()
        .addOption('', 'Загрузка филиалов...')
        .setDisabled(true);
    
    // Добавляем класс для стилизации
    this.pvzSelect.element.addClass('loading');
}

/**
 * Сбросить селект филиалов
 */
resetPvzSelect() {
    this.pvzSelect.clearOptions()
        .addOption('', 'Пожалуйста, сначала выберите город')
        .setDisabled(true);
    
    // Удаляем класс загрузки
    this.pvzSelect.element.removeClass('loading');
    
    // Очищаем код адреса отправления
    $('#marketplacecalculation-dispatch_address_code').val('');
}


    loadPvzList(townCode) {
    const self = this;
    
    // Добавляем таймаут для предотвращения слишком частых запросов
    clearTimeout(this.pvzLoadTimeout);
    this.pvzLoadTimeout = setTimeout(() => {
        MarketplaceApiService.loadPvzList(townCode)
            .then(function(data) {
               
                self.pvzSelect.element.removeClass('loading');
                
                if (Array.isArray(data) && data.length > 0) {
                    self.pvzSelect.clearOptions()
                        .addOption('', 'Выберите филиал');
                    
                    self.populatePvzSelect(data);
                    self.pvzSelect.setDisabled(false);
                } else {
                   self.loadParentPvzList(townCode); 
                  
               }
                
            })
            .fail(function() {
                // Удаляем класс загрузки
                self.pvzSelect.element.removeClass('loading');
                
                self.pvzSelect.clearOptions()
                    .addOption('', 'Ошибка загрузки филиалов')
                    .setDisabled(true);
            });
    }, 300); 
}


loadParentPvzList(townCode) {
    const self = this;
    
    // Показываем сообщение о загрузке
    self.pvzSelect.clearOptions()
        .addOption('', 'Загрузка альтернативных филиалов...')
        .setDisabled(false);
    
    MarketplaceApiService.loadParentPvzList(townCode)
        .then(function(data) {
            self.pvzSelect.element.removeClass('loading');
            
            if (Array.isArray(data) && data.length > 0) {
                // Есть родительские ПВЗ - показываем их
                self.pvzSelect.clearOptions()
                    .addOption('', 'Выберите филиал');
                self.populatePvzSelect(data);
                self.pvzSelect.setDisabled(false);
            } else {
                // Нет ни своих, ни родительских ПВЗ
                self.pvzSelect.clearOptions()
                    .addOption('', 'Нет доступных филиалов для этого города')
                    .setDisabled(false);
            }
        })
        .fail(function() {
            self.pvzSelect.element.removeClass('loading');
            self.pvzSelect.clearOptions()
                .addOption('', 'Ошибка загрузки филиалов')
                .setDisabled(false);
        });
}

    populatePvzSelect(data) {
    for (const item of data) {
        if (!item.Name.includes("KIT.TK)_2") && !item.Name.includes("КАШАЛОТ")) {
           
            const optionData = { 
                town: item.Town
            };
         
            if (item.parentTown) {
                optionData.parentTown = item.parentTown;
                console.log('Добавляем parentTown:', item.parentTown, 'для ПВЗ:', item.Code);
            }
            
            this.pvzSelect.addOption(
                item.Code,
                `${item.Name}, ${item.Address}`,
                optionData  
            );
        }
    }
}

    loadKladrCode(townCode) {
        MarketplaceApiService.loadKladrCode(townCode)
            .then(function(data) {
                if (data && data.kladrcode) {
                    $('#marketplacecalculation-city_pickup_code').attr('data-kladrcode', data.kladrcode);
                    $('#marketplacecalculation-kladrcode').val(data.kladrcode);
                }
            })
            .fail(function() {
                console.log('Ошибка при загрузке kladrkode');
            });
    }

   
    loadDispatchCode(townCode) {
    MarketplaceApiService.loadDispatchCode(townCode)
        .then(function(dispatchCode) {
            if (dispatchCode) {
                $('#marketplacecalculation-dispatch_address_code').val(dispatchCode);
                console.log('Код отправления установлен:', dispatchCode);
            }
        })
        .fail(function() {
            console.log('Ошибка при загрузке кода отправления');
        });
}

    bindPlacesEvents() {
        const self = this;

        $('.add-place').on('click', function() {
            self.placesManager.addPlace();
        });

        $(document).on('click', '.remove-place', function() {
            const placeElement = $(this).closest('.place');
            const index = $('.place').index(placeElement);
            self.placesManager.removePlace(index);
        });

        $(document).on('input', '.length, .width, .height, .weight', function() {
            const place = $(this).closest('.place');
            const index = $('.place').index(place);
            const value = parseFloat($(this).val()) || 0;
            const maxValue = parseFloat($(this).attr('max'));

            if (value > maxValue) {
                MarketplaceNotificationService.showError(
                    'Превышение размера',
                    'Максимально допустимое значение: ' + maxValue + ' см'
                );
                $(this).val(maxValue);
            }

            if (index >= 0 && index < self.placesManager.places.length) {
                self.placesManager.places[index].updateIndicators(self.placesManager.currentTariff);
            }
        });
    }

    bindTariffEvents() {
        const self = this;


        $('.tariff-card').click(function() {
            const newTariff = $(this).data('tariff');
            const radioInput = $(this).find('input[type="radio"]');

            if (self.placesManager.currentTariff !== newTariff) {
                MarketplaceNotificationService.showConfirm(
                    'Смена тарифа',
                    `Переключить на тариф "${newTariff === 'big' ? 'Паллет' : 'Короб'}"?`
                ).then((result) => {
                    if (result.isConfirmed) {
                        self.placesManager.setTariff(newTariff);
                        $('.tariff-card').removeClass('active');
                        $(this).addClass('active');
                        radioInput.prop('checked', true);
                    }
                });
            }
        });


        $(document).on('click', '.switch-tariff', function(e) {
            e.preventDefault();
            const newTariff = $(this).data('tariff');
            $(`.tariff-card[data-tariff="${newTariff}"]`).click();
        });
    }

    /**
 * Привязка события отправки формы
 */
bindFormSubmit() {
    const self = this;
    
    $('form').on('submit', function(e) {
        e.preventDefault();
        
        // Проверка выбора города
        if (!$('#marketplacecalculation-kladrcode').val()) {
            MarketplaceNotificationService.showError('Ошибка', 'Пожалуйста, выберите город отправления');
            return false;
        }
        
        // Проверка выбора филиала
        if (!self.pvzSelect.getValue()) {
            MarketplaceNotificationService.showError('Ошибка', 'Пожалуйста, выберите филиал отправления');
            $('.pvz-error').show();
            return false;
        } else {
            $('.pvz-error').hide();
        }
        
        // Проверка валидности мест
        const validationResult = self.placesManager.validatePlaces();
        
        if (!validationResult.isValid) {
            MarketplaceNotificationService.showError('Ошибка', validationResult.message);
            return false;
        }
        
        // Показываем индикатор загрузки
        MarketplaceNotificationService.showLoading();
        
        // Собираем данные формы
        const formData = self.collectFormData();
        
        // Отправляем запрос на расчет
        MarketplaceApiService.calculateDelivery(formData)
            .then(function(response) {
                console.log('Response:', response);
                MarketplaceNotificationService.close();
                
                if (response.success) {
                    MarketplaceNotificationService.showSuccess('Успешно', 'Расчет выполнен!');
                    self.displayCalculationResult(response.data);
                } else {
                    MarketplaceNotificationService.showError(
                        'Ошибка',
                        response.validate ? JSON.stringify(response.validate) : 'Ошибка расчета'
                    );
                }
            })
            .fail(function(xhr, status, error) {
                MarketplaceNotificationService.close();
                MarketplaceNotificationService.showError('Ошибка', 'Ошибка при отправке запроса: ' + error);
            });
    });
}


   collectFormData() {
    const kladrcode = $('#marketplacecalculation-kladrcode').val();
    const pickUpValue = $('#pick_up').is(':checked') ? '1' : '0';

    return {
        city_pickup_code: kladrcode.slice(0, 2) + kladrcode.slice(3),
        city_delivery_code: $('#marketplacecalculation-city_delivery_code').val() || null,
        dispatch_address_code: $('#marketplacecalculation-dispatch_address_code').val(),
        pick_up: pickUpValue,
        declared_price: parseInt($('#marketplacecalculation-declared_price').val()) || 0,
        sender: {
            debitor: '0001011311',
            ...(pickUpValue === '1' ? { legal_street: "Заборная" } : {})
        },
        type: '09',
        places: this.placesManager.getPlacesData()
    };
}
    displayCalculationResult(data) {

        this.clearCalculationResults();

        if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
            $('#calculation-result').html('<p>Нет данных для отображения.</p>');
            return;
        }

        let html = '';

         for (let key in data) {
        if (data.hasOwnProperty(key)) {
            let serviceWrapper = data[key];
            let innerKey = Object.keys(serviceWrapper)[0];
            let service = serviceWrapper[innerKey];
            
            let totalCost = String(service.cost || '0');
            let time = String(service.time || '');
            let currency_code = String(service.currency_code || '₽');
            
            html += `
                <div class="card mb-3">
                    <div class="card-header bg-success text-white">
                        <b>${service.name || 'Маркетплейс'}</b>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <h5>Итого: <strong>${totalCost} ${currency_code}</strong></h5>
                            </div>
                            <div class="col-md-6">
                                <h5>Срок: <strong>${time} дн.</strong></h5>
                            </div>
                        </div>
                        
                        <h6 class="border-bottom pb-2">Детализация услуг:</h6>
                        <ul class="list-group list-group-flush">
            `;
            
           
            if (service.detail && Array.isArray(service.detail)) {
                service.detail.forEach(item => {
                    if (item.price > 0) {
                        html += `
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span>
                                  ${item.name}
                                </span>
                                <span class="text-success">${item.price} ${currency_code}</span>
                            </li>
                        `;
                    }
                });
            }
            
            html += `
                        </ul>
                    </div>
                </div>
            `;
        }
    }
    
        $('#calculation-result').html(html);
    }

    bindSelect2FocusEvents() {
  
    this.pvzSelect.element.on('select2:open', function() {
        $('.pvz-error').hide();
    });
    
    this.pvzSelect.element.on('select2:opening', function(e) {
        if (!$('#marketplacecalculation-kladrcode').val()) {
            MarketplaceNotificationService.showError('Ошибка', 'Пожалуйста, сначала выберите город отправления');
            e.preventDefault();
        }
    });

      this.deliveryBranchsSelect.element.on('select2:opening', function(e) {
        if (!$('#delivery_city_select').val()) {
            MarketplaceNotificationService.showError('Ошибка', 'Пожалуйста, сначала выберите город получения');
            e.preventDefault();
        }
    });
    
}
}